import { render, staticRenderFns } from "./EmailTemplateCreator.vue?vue&type=template&id=0cdadb6c&scoped=true&"
import script from "./EmailTemplateCreator.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateCreator.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateCreator.vue?vue&type=style&index=0&id=0cdadb6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdadb6c",
  null
  
)

export default component.exports